import React, { useState } from 'react';
import { useColleges, domainForFavicon, findCollegeByUnitid } from '../utils/colleges';

// Initials monogram fallback (mirrors the iOS SchoolCrest visual).
function Monogram({ schoolName, size }) {
  const initials = (schoolName || '?')
    .split(/\s+/)
    .filter((w) => w && !/^(of|the|at|and|in)$/i.test(w))
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
  // Hash the name to pick a stable colour from a small palette.
  const palette = ['#0066CC', '#AF52DE', '#FF9500', '#34C759', '#FF3B30', '#5856D6'];
  let h = 0;
  for (let i = 0; i < (schoolName || '').length; i++) h = (h * 31 + schoolName.charCodeAt(i)) | 0;
  const bg = palette[Math.abs(h) % palette.length];
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        background: bg,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.4,
        userSelect: 'none',
        flexShrink: 0,
      }}
      aria-label={schoolName || ''}
    >
      {initials || '?'}
    </div>
  );
}

/// Three-step cascade matching the iOS CollegeLogoView:
///   1. `logoUrl` (mascotdb athletic mascot when present)
///   2. Google s2 favicon derived from the IPEDS `inst_url` for `unitid`
///   3. Initials monogram
export default function CollegeLogo({ schoolName, logoUrl, unitid, size = 36, className }) {
  const colleges = useColleges();
  const [primaryFailed, setPrimaryFailed] = useState(false);
  const [faviconFailed, setFaviconFailed] = useState(false);

  const college = findCollegeByUnitid(colleges, unitid);
  const faviconDomain = college ? domainForFavicon(college.w) : null;
  const faviconUrl = faviconDomain
    ? `https://www.google.com/s2/favicons?domain=${faviconDomain}&sz=128`
    : null;

  const showPrimary = logoUrl && !primaryFailed;
  const showFavicon = !showPrimary && faviconUrl && !faviconFailed;

  if (showPrimary) {
    return (
      <img
        src={logoUrl}
        alt={schoolName || ''}
        className={className}
        style={{ width: size, height: size, objectFit: 'contain', borderRadius: 8, flexShrink: 0 }}
        onError={() => setPrimaryFailed(true)}
      />
    );
  }
  if (showFavicon) {
    return (
      <img
        src={faviconUrl}
        alt={schoolName || ''}
        className={className}
        style={{ width: size, height: size, objectFit: 'contain', borderRadius: 8, flexShrink: 0 }}
        onError={() => setFaviconFailed(true)}
      />
    );
  }
  return <Monogram schoolName={schoolName} size={size} />;
}
